import React from "react";
import { Chip as ChipMui } from "@mui/material";
import { If, Then, Else } from "react-if";

interface IActivationChip {
  isActive: boolean;
}

const Chip = (props: IActivationChip) => {
  const { isActive } = props;
  return (
    <ChipMui
      className="flex"
      label={
        <span className="px-3 font-medium uppercase">
          <If condition={isActive}>
            <Then>Activo</Then>
            <Else>Inactivo</Else>
          </If>
        </span>
      }
      color={isActive ? "success" : "error"}
      variant="filled"
    />
  );
};

export default Chip;
